import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C8TimeSeriesEdit } from "./edit";
import { C8TimeSeriesNew } from "./new";
import { C8TimeSeriesTable } from "./table";

export default function C8TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C8TimeSeriesEdit />} />
      <Route index element={<C8TimeSeriesTable />} />
      <Route path="/new" element={<C8TimeSeriesNew />} />
    </Routes>
  );
}
